module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAABHNCSVQICAgIfAhkiAAAAPdJREFUOI2tk9GNgzAQRGdRCrhS1ph/SEmpAKiAElJKyD+5uCLmPog5X4wh4hjJEtJqHzveMXCQxH+oFtUegHNDP4PU2Ns/hqnc8zENpMZyL8X3nqLCBxa9nVARCBhLiKzCVPPSue82Od4e+d4s/ltR+bNUSwG3rPUTIK8h0gDs1dgbKOele1q1plpUYV01r8O4pK0ZSzWWvzbGEmTj669LjixG1uZwzcruEHYA2mkiew3BSVAEdkOvJv/6Y5/ZZRlENpsRoFwAOMh4haBTYzvfCwSPdk2vTU0BFNagtO9b27Q2Sxg+7CjV0dYWRWlBObvnQ5IZOko/P6Jp6EQCvMkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/TjianliQuality.png
// module id = xITG
// module chunks = 1